import React from "react";

const Banner = () => {
  return (
    <div className="container mx-auto mx-45 px-0">
      <h1 className=" text-center text-5xl my-31 mr-47 md:mr-0 font-bold lg:mb-58 lg:mt-14 mb-10">
        Kenapa Trawlpack
      </h1>
      <div className="flex flex-col md:flex-row">
        <img
          // style={{width:"70%", height:"90%"}}
          src="https://media.graphassets.com/BxE1w6B4T0C9r0qvUNob"
          alt=""
          className="w-full md:h-4/5 md:w-3/4"
        />
        <div className="flex flex-col space-y-10">
          <div>
            <h1 className="pr-8 font-bold text-[28px] w-auto ml-[12px]" >
              Bisa Kirim Barang Mulai Dari 10 kg dengan Harga Cargo
            </h1>
            <p className="pr-8 w-auto md:w-[400px] ml-[12px]">
              Bisa kirim barang mulai dari 10 kg dengan harga cargo yang lebih murah dengan Trawlpack.
            </p>
            {/* <div className="flex gap-2 mt-2">
              <p className="text-merah mb-10">Baca Selengkapnya</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </div> */}
          </div>
          <div>
            <h1 className="pr-8 font-bold text-[28px] w-auto ml-[12px] ">
              Bisa Jemput Dimana Saja
            </h1>
            <p className="pr-8 w-auto md:w-[400px] ml-[12px]">
              Bisa jemput dimana saja dengan armada motor dan truk, mulai paket kecil hingga barang besar.
            </p>
            {/* <div className="flex gap-2 mt-2 ml-[12px] ">
              <p className="text-merah mb-10">Baca Selengkapnya</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </div> */}
          </div>
          <div>
            <h1 className="pr-8 font-bold text-[28px] w-auto ml-[12px]">
              Jaminan Keamanan Asuransi Barang
            </h1>
            <p className="pr-8 w-auto md:w-[400px] ml-[12px]">
              Jaminan Keamanan Asuransi Barang dari kehilangan dan kerusakan saat pengiriman.
            </p>
            {/* <div className="flex gap-2 mt-2 ml-[12px]">
              <p className="text-merah">Baca Selengkapnya</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </div> */}
          </div>
          <div>
            <h1 className="pr-8 font-bold text-[28px] w-auto ml-[12px]">
              Bisa Lacak Status Barang Kapan Saja
            </h1>
            <p className="pr-8 w-auto md:w-[400px] ml-[12px]">
              Bisa lacak status barang kapan saja dengan teknologi terkini di aplikasi Trawlbens
            </p>
            {/* <div className="flex gap-2 mt-2">
              <p className="text-merah mb-10">Baca Selengkapnya</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </div> */}
          </div>
        </div>
      </div>
      <div className="fixed-right">
        <a href="https://wa.me/6281399000000" rel="noreferrer" target="_blank">
          <button className="bg-hijau text-putih py-2 px-8 rounded-full mb-4 text-sm font-bold md:text-lg md:py-2 md:px-12 md:mr-2">
            <div className="flex gap-2">
              <img
                src="https://img.icons8.com/material-outlined/36/ffffff/whatsapp--v1.png"
                alt="whatsapp"
                className="h-2/6 pt-0 md:pt-2"
              />
              <div>
                <p>Marketing & Sales</p>
                <p>0813 99 000 000</p>
              </div>
            </div>
          </button>
        </a>
      </div>
    </div>
  );
};

export default Banner;
